import { FindingEvidence } from '@/components/evidence/EvidenceReferenceButton'
import { Card } from '@/components/ui/card'
import type { HypothesisFinding } from '@/types/hypothesis-finding'
import { FindingActions, type FindingPromotion } from './FindingActions'

/** A finding backed only by source rows: saving it makes an investigation of its
 *  snippets alone (PRD-0076 SC-017). */
export function SourceFindingCard({
  finding,
  caseId,
  presentation,
  promotion,
}: {
  finding: HypothesisFinding
  caseId: string
  presentation: { index?: number; highlighted?: boolean }
  promotion: FindingPromotion
}) {
  return (
    <Card
      size="compact"
      className={`flex flex-col gap-3 p-4 md:p-5 ${presentation.highlighted ? 'ring-2 ring-primary' : ''}`}
    >
      <h3 className="break-words text-base font-semibold">
        {presentation.index !== undefined && (
          <span className="mr-2 text-xs text-muted-foreground">F{presentation.index + 1}</span>
        )}
        {finding.title}
      </h3>
      <p className="break-words text-sm text-foreground">{finding.description}</p>
      {finding.evidenceSummary && (
        <p className="break-words text-xs text-muted-foreground">{finding.evidenceSummary}</p>
      )}
      <FindingEvidence caseId={caseId} references={finding.evidenceReferenceIds} />
      <FindingActions
        caseId={caseId}
        investigationId={finding.promotedInvestigationId}
        promotion={promotion}
      />
    </Card>
  )
}
